const DEFAULT_BASE_URL = "https://usersound.com";

/**
 * Returns the portal base URL. Pass env value from platform (e.g. EXPO_PUBLIC_*, VITE_*).
 */
export function getPortalBaseUrl(envBaseUrl?: string): string {
  const trimmed = envBaseUrl?.trim();
  return (trimmed && trimmed) || DEFAULT_BASE_URL;
}

/**
 * Builds the portal page URL for a project (`/survey/{projectId}/` on the host).
 * When `responseId` is set, uses `/survey/{projectId}/{responseId}/` (legacy resume path).
 */
export function buildProjectUrl(
  projectId: string,
  userId: string,
  baseUrl?: string,
  responseId?: string
): string {
  const base = (baseUrl ?? getPortalBaseUrl()).replace(/\/$/, "");
  const id = projectId.trim();
  const rid = responseId?.trim();
  const surveyPath = rid
    ? `survey/${encodeURIComponent(id)}/${encodeURIComponent(rid)}/`
    : `survey/${id}/`;
  return `${base}/${surveyPath}?user_id=${encodeURIComponent(userId)}`;
}
